execv2.history.objects = {

    container: document.getElementById("containerHistory"),
    containerRender: document.getElementById("containerHistoryRender"),
    spinner: document.getElementById("containerHistory")!=null? document.getElementById("containerHistory").querySelector(".spinner") : null,
    template: '<div class="row mt-4" data-id="{cfet}" id="history-{cfet}">\
                    <div class="col-2 col-md-1 avatar">\
                        {av}\
                    </div>\
                    <div class="d-none d-md-block col-md-3">\
                        <h5 class="bold m-0">{dn}</h5>\
                        <span class="extra-small {show_uon}">({uont} {uon})</span>\
                    </div>\
                    <div class="col small">\
                        <div class="d-md-none">\
                            <h5 class="bold m-0">{dn}</h5>\
                        </div>\
                        {dstt}\
                    </div>\
                    <div class="d-none d-md-flex col-md-2 small">\
                        {dted}, {hred}\
                    </div>\
                    <div class="col-2">\
                        <span class="badge badge-light-secondary">{dfr}</span>\
                        <div class="small mt-2">{dr}</div>\
                    </div>\
                </div><hr/>'
}

execv2.history.list = function () {

    if (execv2.objects.isTask && execv2.history.objects.container!=null) {

        execv2.history.spinner.show();

        var postdata = {
            "cfe": execv2.objects.codFlowExecute
        }

        h.postJSON(
            execv2.services.urlHistory + "?" + (new URLSearchParams(postdata).toString()),
            function (data) {

                if (data != null && data.success != null) {

                    h.forEach(data.success, function (i, item) {

                        
                        var html = execv2.history.objects.template;

                        html = html.replace(/{cfet}/gi, item.cfet);
                        html = html.replace(/{av}/gi, item.av);
                        html = html.replace(/{dn}/gi, item.dn);
                        html = html.replace(/{uon}/gi, item.uon);
                        html = html.replace(/{uont}/gi, item.uont);
                        html = html.replace(/{show_uon}/gi, item.uon!=""?"d-block":"d-none");
                        html = html.replace(/{dstt}/gi, item.dstt);
                        html = html.replace(/{dted}/gi, item.dted);
                        html = html.replace(/{hred}/gi, item.hred);
                        html = html.replace(/{dfr}/gi, item.dfr);
                        html = html.replace(/{dr}/gi, item.dr);

                        execv2.history.objects.containerRender.insertAdjacentHTML('beforeend', html);
                        
                        var el = execv2.history.objects.containerRender.lastChild;
                        
                       
                        bsml.convertIcons(execv2.messages.objects.containerMessages);
                    });
                }

                execv2.history.spinner.hide();

            }
        );
    }
}

execv2.history.spinner = {

    show: function () {
        h.removeClass(execv2.history.objects.spinner, "d-none");
    },
    hide: function () {
        h.addClass(execv2.history.objects.spinner, "d-none");
    }
}


execv2.history.list();



